var _g, _path, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBox3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_11109_1530)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 72,
    r: 32,
    fill: "url(#paint0_linear_11109_1530)",
    fillOpacity: 0.3
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11109_1530",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 45,
    width: 53,
    height: 53
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.2524 97.249V46.7466H46.75V97.249H97.2524Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11109_1530)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.3495 76.8337L46.7954 61.3942C46.7 61.1252 46.8417 60.8273 47.1107 60.7289C50.0497 59.6733 53.116 58.6406 56.2113 57.5995M85.6679 87.7756L67.9239 94.1533L60.1366 96.9531C59.8677 97.0515 59.5697 96.9097 59.4714 96.6408L53.5181 80.0819",
    stroke: "url(#paint1_linear_11109_1530)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1751 87.1739L70.7484 90.3325L62.5909 91.7324C62.3103 91.7786 62.0385 91.5877 61.9892 91.3071L58.9779 73.736L55.6599 54.3917C55.6365 54.2559 55.6678 54.1165 55.7469 54.0037C55.8261 53.891 55.9466 53.8142 56.0822 53.7901L65.3795 52.1964",
    stroke: "url(#paint2_linear_11109_1530)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3828 68.0311V47.553C65.3831 47.4096 65.4402 47.2722 65.5416 47.1709C65.643 47.0695 65.7804 47.0124 65.9238 47.0122H90.5148C90.6796 47.0122 90.726 47.0787 91.0066 47.3448L96.9395 53.0023C97.1796 53.2366 97.2462 53.2626 97.2462 53.4188V86.6291C97.2462 86.927 97.0032 87.1729 96.7053 87.1729H65.9238C65.6259 87.1729 65.3828 86.927 65.3828 86.6291V71.5655",
    stroke: "url(#paint3_linear_11109_1530)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1055 47.0135L90.117 52.3789C90.117 53.5792 91.2163 53.5039 91.7456 53.5039H97.2418",
    stroke: "url(#paint4_linear_11109_1530)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3497 58.0791H70.5703",
    stroke: "url(#paint5_linear_11109_1530)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3497 63.4912H70.5703",
    stroke: "url(#paint6_linear_11109_1530)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3497 68.9014H70.5703",
    stroke: "url(#paint7_linear_11109_1530)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3497 74.3135H70.5703",
    stroke: "url(#paint8_linear_11109_1530)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3497 79.7256H70.5703",
    stroke: "url(#paint9_linear_11109_1530)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_11109_1530",
    x: 0,
    y: 0,
    width: 144,
    height: 144,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "effect1_foregroundBlur_11109_1530"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11109_1530",
    x1: 34.8685,
    y1: 52.5359,
    x2: 115.172,
    y2: 53.7333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA75F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6EE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11109_1530",
    x1: 43.6464,
    y1: 89.2699,
    x2: 92.4588,
    y2: 88.551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA75F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6EE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11109_1530",
    x1: 52.9645,
    y1: 83.9939,
    x2: 95.0293,
    y2: 83.4621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA75F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6EE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_11109_1530",
    x1: 62.828,
    y1: 79.3065,
    x2: 102.811,
    y2: 78.8334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA75F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6EE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_11109_1530",
    x1: 89.5333,
    y1: 52.2334,
    x2: 98.4871,
    y2: 52.0866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA75F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6EE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_11109_1530",
    x1: 68.824,
    y1: 57.8832,
    x2: 93.5495,
    y2: 49.853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA75F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6EE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_11109_1530",
    x1: 68.824,
    y1: 63.2953,
    x2: 93.5495,
    y2: 55.2651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA75F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6EE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_11109_1530",
    x1: 68.824,
    y1: 68.7055,
    x2: 93.5495,
    y2: 60.6753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA75F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6EE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_11109_1530",
    x1: 68.824,
    y1: 74.1176,
    x2: 93.5495,
    y2: 66.0874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA75F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6EE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_11109_1530",
    x1: 68.824,
    y1: 79.5297,
    x2: 93.5495,
    y2: 71.4995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA75F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6EE6"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox3);
export default __webpack_public_path__ + "static/media/box3.ca2e73de51b8e915d94ee02ec8799201.svg";
export { ForwardRef as ReactComponent };